import React from "react";
import { Link } from "react-router-dom";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // Production: integrate with Sentry, Datadog, etc.
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 rounded-full bg-brand-aqua-light flex items-center justify-center mx-auto mb-4">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#69c0ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
            </div>
            <h1 className="font-heading text-2xl font-bold text-brand-black mb-2">Something went wrong</h1>
            <p className="text-brand-grey mb-6">We&apos;re sorry — an unexpected error occurred. Please try refreshing the page.</p>
            <div className="flex flex-wrap gap-3 justify-center">
              <button onClick={() => window.location.reload()} className="bg-brand-aqua hover:bg-brand-aqua-dark text-white font-semibold rounded-full px-6 py-2.5 text-sm transition-colors">
                Refresh Page
              </button>
              <a href="/" className="bg-gray-100 hover:bg-gray-200 text-brand-black font-semibold rounded-full px-6 py-2.5 text-sm transition-colors">
                Go to Homepage
              </a>
            </div>
            <p className="text-xs text-brand-grey mt-6">If this keeps happening, call us on <a href="tel:+448003682989" className="text-brand-aqua">0800 368 2989</a></p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
